(ns minorodata.sentry.events
  (:require
   [minorodata.app.config :as app.config]
   [re-frame.core :as re-frame]
   [applied-science.js-interop :as js-interop]
   ["@sentry/react" :as Sentry]))


(def development?
  ^boolean goog.DEBUG)

(defn get-environment []
  (let [host (js-interop/get-in js/window [:location :hostname])]
    (cond
     (or (= "127.0.0.1" host)
         (= "localhost" host))
     "local"

     (re-matches #".*\.dev\..*" host)
     "dev"

     (re-matches #".*\.stg\..*" host)
     "staging"

     (re-matches #".*\.kleene.ai" host)
     "production"

     :else
     "unknown")))


(re-frame/reg-event-fx
 :sentry/init
 (fn [_ _]
   (let [current-env (get-environment)]
     (.init Sentry #js {:dsn         app.config/sentry-dsn
                        :debug       development?
                        :release     minorodata.app.config/VERSION
                        :environment current-env
                        :onerror     true})
     nil)))


;; Expects a string
(re-frame/reg-event-fx
 :sentry/capture-message
 (fn [_ [_ message]]
   (.captureMessage Sentry message)
   nil))


;; Expects js/Error
(re-frame/reg-event-fx
 :sentry/capture-exception
 (fn [_ [_ e]]
   (.captureException Sentry e)
   nil))


;; Expects {:message "Message" :stacktrace [ ... ]}
(re-frame/reg-event-fx
 :sentry/capture-event
 (fn [_ [_ event]]
   (.captureEvent Sentry (clj->js event))
   nil))


;; Expects k as string parameter name and v as an arbitrary value
(re-frame/reg-event-fx
 :sentry/set-extra
 (fn [_ [_ k v]]
   (.setExtra Sentry k v)
   nil))


;; Expects k as string parameter name and v as string
(re-frame/reg-event-fx
 :sentry/set-tag
 (fn [_ [_ k v]]
   (.setTag Sentry k v)
   nil))


;; Expects a map of parameters: {:id 123 :login "hello"}
(re-frame/reg-event-fx
 :sentry/set-user
 (fn [_ [_ user-data]]
   (.setUser Sentry (clj->js user-data))
   nil))


;; Expects a map of parameters: {:message "My Breadcrumb"}
(re-frame/reg-event-fx
 :sentry/set-breadcrumb
 (fn [_ [_ breadcrumb]]
   (.addBreadcrumb Sentry (clj->js breadcrumb))
   nil))
